import type { CompareProduct } from '@iheartjane/menu';
import { hideStrikethroughPrice, productPhotoMetadata } from '@iheartjane/menu';

import { getDefaultWeightPricing } from '@jane/bloom/viewModels/buildProductCardProps';
import { hasSpecialApplied } from '@jane/bloom/viewModels/getPrice';
import type { ProductSearchResultViewModel } from '@jane/bloom/viewModels/productSearch';

type BuildCompareProductArgs = {
  product: ProductSearchResultViewModel;
  /** Store state (e.g. "CA") — used to honor per-store strikethrough suppression */
  storeState?: string | null;
};

export function buildCompareProduct({
  product,
  storeState,
}: BuildCompareProductArgs): CompareProduct {
  const { url: imageUrl } = productPhotoMetadata(product);

  const { priceIsDiscounted } = getDefaultWeightPricing(product);
  const isDiscounted = Boolean(hasSpecialApplied(product)) && priceIsDiscounted;
  const showStrikethrough =
    isDiscounted && !hideStrikethroughPrice(storeState ?? '');

  return {
    activities: product.activities ?? [],
    aggregateRating: product.aggregate_rating,
    availableWeights: product.available_weights ?? [],
    brand: product.brand ?? null,
    category: product.category ?? null,
    dosage: product.dosageAmountPackInfo || null,
    feelings: product.feelings ?? [],
    flavors: product.flavors?.map((f) => f.title) ?? [],
    id: product.product_id,
    imageUrl,
    kind: product.kind,
    name: product.name,
    originalPrice: showStrikethrough ? product.priceLabel || null : null,
    percentCbd:
      product.percent_cbd != null ? Number(product.percent_cbd) : null,
    percentThc:
      product.percent_thc != null ? Number(product.percent_thc) : null,
    price: product.discountedPriceLabel || null,
    reviewCount:
      product.review_count != null ? Number(product.review_count) : null,
    url: `/products/${product.product_id}/${product.unique_slug ?? product.id}`,
  };
}
